import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userLogout } from "../../store/auth/auth.slice";

const baseQueryWithAuth = (baseQuery) => async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error?.status === 401) {
    api.dispatch(userLogout());
    return result;
  }

  if (result.data?.error?.status === 401) {
    api.dispatch(userLogout());
    return {
      error: {
        status: 401,
        data: result.data.error,
      },
    };
  }

  return result;
};

export const createBaseQuery = (baseUrl, includeAuth = false) =>
  baseQueryWithAuth(
    fetchBaseQuery({
      baseUrl,
      prepareHeaders: (headers, { getState, endpoint }) => {
        if (endpoint?.includes("data-imports")) {
          headers.set("Content-Type", "multipart/form-data");
        }
        headers.set("tenant-id", "99999");
        headers.set("product-id", "100");
        headers.set("platform", "web");

        if (includeAuth) {
          const token = getState().auth?.tokens?.access_token;
          if (token) {
            headers.set("Authorization", `Bearer ${token}`);
          }
        }

        return headers;
      },
    })
  );
